import { Text, useColorMode, useColorStyle } from '@tonic-one/react';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import { useTranslation } from 'react-i18next';
import { getUtcTime } from '../../../utils/time';

type TimeRangeLabelProps =
  | { start: string; end: string; style?: Object }
  | { start: Date; end: Date; style?: Object };

const convertToISOString = (time: Date | string) => {
  return typeof time === 'string' ? time : time.toISOString();
};

export const TimeRangeLabel = ({
  start: startProp,
  end: endProp,
  style = {},
}: TimeRangeLabelProps) => {
  const { offset } = useUtcOffsetStore();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('common');
  const timeFormat = t('common.momentDateFormat');
  const start = getUtcTime(convertToISOString(startProp), offset, timeFormat);
  const end = getUtcTime(convertToISOString(endProp), offset, timeFormat);

  return (
    <Text color={colorStyle.color.tertiary} {...style}>
      {`${start} - ${end}`}
    </Text>
  );
};
